import { FormGroup, Input, Label } from "reactstrap";
import { SongUb } from "../../gql/graphql";
import { useTranslation } from "react-i18next";
import { formatAbsoluteDateTime } from "./dateTime";

interface Props {
  song: SongUb;
}

export function MetadataCard({ song }: Props) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <FormGroup>
        <Label for="createdAt">{t("items.metadata.createdAt")}</Label>
        <Input
          id="createdAt"
          name="createdAt"
          value={formatAbsoluteDateTime(song.createdAt, i18n.language)}
          disabled={true}
          className="form-control-readonly"
        />
      </FormGroup>
      <FormGroup>
        <Label for="updatedAt">{t("items.metadata.updatedAt")}</Label>
        <Input
          id="updatedAt"
          name="updatedAt"
          value={formatAbsoluteDateTime(song.updatedAt, i18n.language)}
          disabled={true}
          className="form-control-readonly"
        />
      </FormGroup>
      <FormGroup>
        <Label for="lastUpdatedBy">{t("items.metadata.updatedBy")}</Label>
        <Input
          id="lastUpdatedBy"
          name="lastUpdatedBy"
          value={song.lastUpdatedBy}
          disabled={true}
          className="form-control-readonly"
        />
      </FormGroup>
    </>
  );
}
